/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { workScheduleScheduleSchema } from "./workScheduleScheduleSchema.ts";

export const scheduleSchema = z.object({
	schedule_by_day: z.array(workScheduleScheduleSchema),
	close_time_disclaimer_text: z.string(),
	timezone: z.string(),
	hash_sum: z.string(),
});
